// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

export const headerConstants = {
  secureMyProject: 'Secure My Project',
  blueBracketError: 'BluBracket data is currently unavailable.',
};
